/**
 * Belgeleri API'ye yükler
 * 
 * @param {Object} options - Yapılandırma seçenekleri
 * @param {Object} options.axios - Axios örneği
 * @param {Object} options.settings - URL ayarları
 * @param {String} options.assetId - Geçerli varlık ID'si
 * @param {Array} options.files - Meta verilerle birlikte yüklenecek dosyalar
 * @returns {Promise<Object>} - API yanıtı
 */
export const uploadDocuments = async (options) => {
  const { axios, settings, assetId, files } = options;
  
  if (!files || files.length === 0) {
    throw new Error('Yüklenecek dosya yok');
  }
  
  // FormData nesnesini oluştur
  const formData = new FormData();
  formData.append('assetId', assetId);

  // Her dosya için kategori ID'lerini saklayacak ayrı bir nesne oluştur
  const allCategoryIds = {};
  
  // Şimdi her dosyayı ve meta verilerini FormData'ya ekle
  files.forEach((fileItem, index) => {
    formData.append(`file`, fileItem.file);
    formData.append(`description[${index}]`, fileItem.description || '');
    
    // Kategori bilgilerini topla
    if (fileItem.categoryIds && fileItem.categoryIds.length > 0) {
      allCategoryIds[index] = fileItem.categoryIds;
      // İlk kategoriyi birincil olarak kullan
      formData.append(`categoryId[${index}]`, fileItem.categoryIds[0]);
    } else if (fileItem.categoryId) {
      formData.append(`categoryId[${index}]`, fileItem.categoryId);
    } else {
      // Varsayılan boş kategori
      formData.append(`categoryId[${index}]`, '');
    }
    
    formData.append(`typeId[${index}]`, fileItem.fileType || '');
  });

  // Tüm kategorileri tek bir JSON nesnesi olarak ekle
  if (Object.keys(allCategoryIds).length > 0) {
    const categoryIdsJson = JSON.stringify(allCategoryIds);
    formData.append('categoryIds', categoryIdsJson);
  }

  try {
    // Original working implementation
    const response = await axios.post(settings.uploadDocumentFiles, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    
    // Fixed memory cleanup - instead of assigning null to formData
    for (const pair of [...formData.entries()]) {
      formData.delete(pair[0]);
    }
    
    return response.data;
  } catch (error) {
    // Memory cleanup
    for (const pair of [...formData.entries()]) {
      formData.delete(pair[0]);
    }
    
    throw error;
  }
}